<template>
  <div>
    <div class='up-button-container' v-if="showUpButton" @click="scrollToTop">
      <div class='btn-floating btn-large waves-effect waves-light blue up-button'>
        <i class='material-icons'>arrow_upward</i>
      </div> 
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScrollUpButton',
  props: {
    scrollToID: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      showUpButton: false
    }
  },
  methods: {
    handleScroll() {
      // console.log(window.scrollY)
      // console.log(this.scrollToID)
      var rect = document.getElementsByTagName('body')[0].getBoundingClientRect()
      if(this.scrollToID != '') {
        rect = document.getElementById(this.scrollToID).getBoundingClientRect()
      }
      
      // console.log(rect)
      if(rect.y < -100) {
        this.showUpButton = true
      }
      else {
        this.showUpButton = false
      }
    },
    scrollToTop() {
      var scrollTop = 200
      if(this.scrollToID != '') {
        scrollTop = document.getElementById(this.scrollToID).offsetTop - 50
      }
      window.scrollTo({
        top: scrollTop,
        // top: 200,
        left: 0,
        behavior: 'smooth'
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .up-button-container {
    float: right;
    /* width: 100px; */
    /* position: sticky; */
    top: 0;
  }

  .up-button {
    position: fixed;
    bottom: 0;
    margin-left: -60px;
    margin-bottom: 10px;
  }
</style>
